import * as React from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  CardActions,
  Stack,
  useTheme,
  Chip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import FruitifyIcon from "../../../shared-components/FruitifyIcons";
import { ChevronRight, Edit } from "@mui/icons-material";
import ExpandableTagsBox from "../../../shared-components/ExpandableTagsBox";

function AssignmentSummaryCard({
  assignment,
  showAnswerCount = false,
  displayMode = "assignment",
  studentView = false,
  showTypeChip = false,
  showSchoolName = false,
}) {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Card
      data-testid={"assignment-summary-card"}
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        width: "100%", // stretch to fill Grid item
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Stack direction={"row"} alignItems={"center"} spacing={1}>
          <Typography
            variant="h6"
            color="text.primary"
            gutterBottom
            sx={{ mb: 0 }}
          >
            {displayMode === "class"
              ? assignment.schoolClass.name
              : assignment.name}
          </Typography>
          {showTypeChip && (
            <Chip label="Assignment" variant="outlined" size="small" />
          )}
          {assignment.isPublished ? (
            <Chip
              label={assignment.status}
              color={
                assignment.status === "Past Deadline" ? "warning" : "success"
              }
              variant={
                assignment.status === "Past Deadline" ? "outlined" : "filled"
              }
              size="small"
            />
          ) : (
            displayMode === "class" && (
              <Chip
                label="Draft"
                color="error"
                variant="outlined"
                size="small"
              />
            )
          )}
        </Stack>
        {showSchoolName && (
          <Typography
            variant="subtitle2"
            color="text.primary"
            gutterBottom
            sx={{ mb: 0 }}
          >
            {assignment.schoolClass.school.name}
          </Typography>
        )}
        <Stack
          direction={"row"}
          spacing={1}
          alignItems={"center"}
          sx={{ mt: 1.5, mb: 1 }}
        >
          <FruitifyIcon
            name={"CalendarToday"}
            sx={{
              width: 18,
              height: 18,
              color: theme.palette.text.secondary,
            }}
          />
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
            <strong>Due: </strong>
            {assignment.dueDate}
          </Typography>
        </Stack>
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          {showAnswerCount ? (
            <>
              <FruitifyIcon
                name={"Assignment"}
                sx={{
                  width: 18,
                  height: 18,
                  color: theme.palette.text.secondary,
                }}
              />
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>Answers: </strong>
                {assignment.answersCount}
              </Typography>
            </>
          ) : (
            <>
              <FruitifyIcon
                name={"School"}
                sx={{
                  width: 18,
                  height: 18,
                  color: theme.palette.text.secondary,
                }}
              />
              <Typography variant="body2" color="text.secondary" gutterBottom>
                <strong>Class: </strong>
                {assignment.schoolClass.name}
              </Typography>
            </>
          )}
        </Stack>
        <ExpandableTagsBox tags={assignment.tags} />
      </CardContent>
      <CardActions sx={{ justifyContent: "flex-end", pt: 0, mt: -0.5 }}>
        <Button
          variant="card-action"
          color="primary"
          onClick={() => navigate(`/assignments/view/${assignment.id}`)}
          endIcon={assignment.isPublished ? <ChevronRight /> : <Edit />}
        >
          {assignment.isPublished
            ? studentView
              ? "Submit"
              : "Review"
            : "Continue"}
        </Button>
      </CardActions>
    </Card>
  );
}

export default AssignmentSummaryCard;
